import { companyInfo, stats } from '../../../mocks/homeData';

const HeroSection = () => {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="about"
      className="relative min-h-screen flex flex-col justify-end overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1296f448c9b6f8eee69e4c9fb145c547.jpg"
          alt="祐灃室內裝修 - 專業木作施工"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70" />
      </div>

      {/* Hero Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pb-16 pt-32">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
          {/* Left: Main Text */}
          <div className="flex-1 max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-amber-400/60 bg-amber-700/20 mb-6">
              <div className="w-1.5 h-1.5 rounded-full bg-amber-400" />
              <span className="text-amber-300 text-xs font-medium tracking-widest">台中市 · 專業木工裝修</span>
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4">
              {companyInfo.name}
            </h1>
            <p className="text-xl md:text-2xl text-amber-300 font-medium mb-4">{companyInfo.slogan}</p>
            <p className="text-white/80 text-base leading-relaxed max-w-lg mb-8">{companyInfo.description}</p>

            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => handleScroll('#services')}
                className="flex items-center gap-2 px-7 py-3.5 rounded-full bg-amber-700 text-white font-semibold text-sm hover:bg-amber-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                查看服務項目
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm" />
                </div>
              </button>
              <button
                onClick={() => handleScroll('#contact')}
                className="flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/60 text-white font-semibold text-sm hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                立即諮詢
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-sm" />
                </div>
              </button>
            </div>
          </div>

          {/* Right: Stats */}
          <div className="grid grid-cols-2 lg:grid-cols-2 gap-4 lg:max-w-xs w-full">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-5 text-center"
              >
                <div className="text-3xl font-bold text-amber-400 mb-1">{stat.value}</div>
                <div className="text-white/80 text-xs tracking-wide">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="mt-12 flex justify-center">
          <button
            onClick={() => handleScroll('#services')}
            className="flex flex-col items-center gap-2 text-white/60 hover:text-white/90 transition-colors cursor-pointer"
          >
            <span className="text-xs tracking-widest">向下探索</span>
            <div className="w-5 h-5 flex items-center justify-center animate-bounce">
              <i className="ri-arrow-down-line" />
            </div>
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
